import { useRouter } from 'next/router';

import { useQuery } from 'react-query';
import { ExploreData } from 'services/explore';

import useExplore from './useExplore';

import FeaturedContent from '../featurecontent/FeaturedContent';
import ExploreSearchWrapper from '../exploresearchwrapper/ExploreSearchWrapper';
import Spinner from '@core/components/spinner/Spinner';

import classes from './ExploreWrapper.module.scss';

const ExploreWrapper = () => {
	const router = useRouter();

	const {
		searchKeyword,
		selectedCategories,
		selectedContent,
		selectedOrdering,
		selectedCareerPath,
		selectedPrice,
		selectedProficiency,
		selectedPage,
		selectedHighlighted,
		handleCategoryClick,
		handlePriceClick,
		handleProficiencyClick,
		handleQueryKeywordChange,
		handleContentTypeSelect,
		handleOrderingChange,
		handleCareerPathChange,
		handlePageChange,
		handleHighlighted,
	} = useExplore();

	const { data, isLoading } = useQuery(
		['explore-data', router.query.featured_contents],
		() => ExploreData.GET(router.query.featured_contents),
		{ enabled: !!router.isReady }
	);

	return (
		<div className="d-flex flex-column gap-4 w-100 my-3 my-lg-0">
			{data && router.isReady && !isLoading ? (
				<div className="d-flex flex-wrap flex-column ">					
					{data?.data?.featured_career_paths && data?.data?.featured_career_paths?.length > 0 && !searchKeyword && (
						<FeaturedContent type='career' content={data?.data?.featured_career_paths} />
					)}
					<ExploreSearchWrapper
						filters={data?.data?.filters}
						searchData={{
							searchKeyword,
							selectedCategories,
							selectedContent,
							selectedOrdering,
							selectedCareerPath,
							selectedPrice,
							selectedProficiency,
							selectedPage,
							selectedHighlighted
						}}
						handleCategoryClick={handleCategoryClick}
						handlePriceClick={handlePriceClick}
						handleProficiencyClick={handleProficiencyClick}
						handleQueryKeywordChange={handleQueryKeywordChange}
						handleContentTypeSelect={handleContentTypeSelect}
						handleOrderingChange={handleOrderingChange}
						handleCareerPathChange={handleCareerPathChange}
						handlePageChange={handlePageChange}
						handleHighlightedChange={handleHighlighted}
					/>
				</div>
			) : (
				<div className="d-flex align-items-center justify-content-center w-100 py-5">
					<Spinner />
				</div>
			)}
		</div>
	);
};

export default ExploreWrapper;
